// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import zhHans from 'vuetify/es5/locale/zh-Hans'
import '@mdi/font/css/materialdesignicons.css'
import VueExcelXlsx from "vue-excel-xlsx";
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(Vuetify)
Vue.use(VueExcelXlsx)
Vue.use(VueReCaptcha, 
  { siteKey: '6Lf8fGQbAAAAAMER76jnRoskfXgEAPCFi_qIDCM4',
    loaderOptions: {
      useRecaptchaNet: true
    } 
  }
)


const opts = {
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    lang: {
      locales: { zhHans },
      current: 'zhHans'
    }
}

export default new Vuetify(opts)


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js